import { Link } from "react-router-dom";
import type { Comic } from "@/types/comic";
import ComicCard from "@/components/base/ComicCard";
import Icon from "@/components/base/Icon";

interface RecommendSectionProps {
  title: string;
  subtitle: string;
  icon: string;
  comics: Comic[];
  moreTo: string;
}

export default function RecommendSection({
  title,
  subtitle,
  icon,
  comics,
  moreTo,
}: RecommendSectionProps) {
  return (
    <section className="w-full px-4 md:px-8 py-10">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center">
            <Icon name={icon} className="w-5 h-5" />
          </span>
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              {title}
            </h2>
            <p className="mt-1 text-xs md:text-sm text-foreground-500">{subtitle}</p>
          </div>
        </div>
        <Link
          to={moreTo}
          className="hidden sm:inline-flex items-center gap-1 text-sm text-foreground-600 whitespace-nowrap cursor-pointer transition-colors hover:text-primary-600"
        >
          查看全部
          <Icon name="ri-arrow-right-s-line" className="w-4 h-4" />
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {comics.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>

      <Link
        to={moreTo}
        className="sm:hidden mt-5 flex items-center justify-center gap-1 py-2.5 rounded-md border border-background-300 text-sm text-foreground-700 cursor-pointer"
      >
        查看全部
        <Icon name="ri-arrow-right-s-line" className="w-4 h-4" />
      </Link>
    </section>
  );
}